import { mergeAttributes, Node, ReactNodeViewRenderer } from "@tiptap/react";
import Snippet from ".";

export default Node.create({
  name: "snippet",

  group: "inline",
  inline: true,

  atom: true,
  selectable: false,

  addAttributes() {
    return {
      name: {
        default: null,
      },
      version_number: {
        default: null,
      },
      label: {
        default: null,
      },
      mounted: {
        default: true,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "snippet",
      },
    ];
  },
  renderText({ node }) {
    const name = node.attrs.name || "";
    const version_number = node.attrs.version_number;
    const label = node.attrs.label;

    let text = `@@@${name}`;
    if (version_number) {
      text += `@version_number:${version_number}`;
    }
    if (label) {
      text += `@label:${label}`;
    }
    text += "@@@";

    return text;
  },

  renderHTML({ HTMLAttributes }) {
    return ["snippet", mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return ReactNodeViewRenderer(Snippet, { contentDOMElementTag: "span" });
  },
});
